import { ApiService } from '../api/ApiService';

export function logSidenavVisit(label: string) {
    ApiService.sendEventCommand(
        `LP Sidenav ${label}`,
        'eventCheck',
        `User opened ${label} from the sidenav`,
    );
}
